"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
var dt = function () { return false; };
var Validator = /** @class */ (function () {
    function Validator() {
    }
    Validator.email = function (input, t) {
        if (t === void 0) { t = dt; }
        /* Really basic test */
        var isValid = (typeof input === "string"
            && input.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null);
        return isValid === true ? true : t("validator.error.email");
    };
    Validator.phone = function (input, t) {
        if (t === void 0) { t = dt; }
        /* International number with a mandatory '+' at begin */
        var isValid = input && (typeof input === "string"
            ? (input.match(/^\+[0-9]{1,3}[0-9]{4,14}$/) !== null)
            : (typeof input.phoneNumber === "string" && input.phoneNumber.match(/^[0-9]{4,14}$/) !== null));
        return isValid === true ? true : t("validator.error.phone");
    };
    Validator.password = function (input, t) {
        if (t === void 0) { t = dt; }
        /* At least 8 characters, one uppercase letter, one lowercase letter and one digit */
        var isValid = (typeof input === "string" && input.match(/^(?=.*[a-z])(?=.*\d).{8,}$/) !== null);
        return isValid === true ? true : t("validator.error.password");
    };
    Validator.float = function (input, t) {
        if (t === void 0) { t = dt; }
        /* Start and end with numbers, may have a decimal point in the middle */
        var isValid = (typeof input === "number"
            || (typeof input === "string" && input.match(/^\d+\.?\d*$/) !== null));
        return isValid === true ? true : t("validator.error.float");
    };
    Validator.integer = function (input, t) {
        if (t === void 0) { t = dt; }
        /* Contains only numbers, no decimal part */
        var isValid = ((typeof input === "number" && input % 1 === 0)
            || (typeof input === "string" && input.match(/^\d+$/) !== null));
        return isValid === true ? true : t("validator.error.integer");
    };
    Validator.taxNumber = function (input, t) {
        if (t === void 0) { t = dt; }
        /* VAT number format check */
        var regex = /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(HR)?[0-9]{11}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL)?[0-9]{9}|ES[A-Z][0-9]{7}(?:[0-9]|[A-Z])|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]{7}[A-Z]{1,2}|(IE)?[0-9][A-Z][0-9]{5}[A-Z]|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/;
        var isValid = (typeof input === "string" && input.match(regex) !== null);
        return isValid === true ? true : t("validator.error.taxNumber");
    };
    Validator.iban = function (input, t) {
        if (t === void 0) { t = dt; }
        /* IBAN number format check */
        var iban = (input || "").replace(/ /g, "").toLocaleUpperCase()
            .replace(/^IBAN/, "");
        var toCheck = iban.slice(4) + iban.slice(0, 4);
        var converted = "";
        for (var _i = 0, toCheck_1 = toCheck; _i < toCheck_1.length; _i++) {
            var char = toCheck_1[_i];
            converted += char.match(/^[A-Z]$/) ? char.charCodeAt(0) - 55 : char;
        }
        var block;
        while (converted.length > 2) {
            block = converted.slice(0, 9);
            converted = parseInt(block, 10) % 97 + converted.slice(block.length);
        }
        var isValid = parseInt(converted, 10) % 97 === 1;
        return isValid === true ? true : t("validator.error.iban");
    };
    return Validator;
}());
exports.Validator = Validator;
//# sourceMappingURL=Validator.js.map